import * as React from 'react';
import { ICheckoutClubInfoCollectorResources } from '../checkout-club-info-collector.props.autogenerated';

import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { MemberData } from '../types/member-type';

export interface IMemberCollector {
    resources: ICheckoutClubInfoCollectorResources;
    allowEdits: boolean;
    formData: MemberData;
    onChange(memberInfo: MemberData): void;
}

/**
 * used to collect data about the current members info
 */
@observer
export class MemberCollector extends React.Component<IMemberCollector> {

    @observable private _firstName: string = '';
    @observable private _lastName: string = '';
    @observable private _spouseFirst: string = '';

    public constructor(props: IMemberCollector) {
        super(props);
        const formData: MemberData = props.formData || {};

        // populate form with any previous saved form data
        this._firstName = formData.firstName || '';
        this._lastName = formData.lastName || '';
        this._spouseFirst = formData.additionalMemberFirstName || '';

        this.props.onChange({
            firstName: this._firstName,
            lastName: this._lastName,
            additionalMemberFirstName: this._spouseFirst
        });

        this._onChange = this._onChange.bind(this);
    }

    public render(): JSX.Element {
        const {
            allowEdits,
            resources: {
                checkoutClubInfoCollector__memberFirstName,
                checkoutClubInfoCollector__memberLastName,
                checkoutClubInfoCollector__additionalMemberFirstName
            }
        } = this.props;
        return (
            <div className='checkout-step-club-info-fields'>
                <div className='checkout-step-club-info-control'>
                    <label htmlFor='first-name'>{checkoutClubInfoCollector__memberFirstName}</label>
                    <input
                        type='text'
                        name='first-name'
                        className='checkout-step-input-first-name'
                        disabled={!allowEdits}
                        value={this._firstName}
                        data-map='_firstName'
                        onChange={this._onChange}
                    />
                </div>
                <div className='checkout-step-club-info-control'>
                    <label htmlFor='last-name'>{checkoutClubInfoCollector__memberLastName}</label>
                    <input
                        type='text'
                        name='last-name'
                        className='checkout-step-input-last-name'
                        disabled={!allowEdits}
                        value={this._lastName}
                        data-map='_lastName'
                        onChange={this._onChange}
                    />
                </div>
                <div className='checkout-step-club-info-control'>
                    <label htmlFor='email'>{checkoutClubInfoCollector__additionalMemberFirstName}</label>
                    <input
                        type='text'
                        name='email'
                        className='checkout-step-input-spouse'
                        disabled={!allowEdits}
                        value={this._spouseFirst}
                        data-map='_spouseFirst'
                        onChange={this._onChange}
                    />
                </div>
            </div>
        );
    }

    private _onChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this[event.target.dataset.map!] = event.target.value;

        this.props.onChange({
            firstName: this._firstName,
            lastName: this._lastName,
            additionalMemberFirstName: this._spouseFirst
        });
    }
}